"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var react_places_autocomplete_1 = require("react-places-autocomplete");
// Extracts one part of the Google-Maps AddressComponent format by key.
exports.extractAddressComponent = function (key, isLong, comps) {
    var match = comps.find(function (comp) { return comp.types.indexOf(key) !== -1; });
    return match ? match[isLong ? 'long_name' : 'short_name'] : '';
};
exports.parseGeocode = function (addressComponents) {
    var city = exports.extractAddressComponent('locality', true, addressComponents);
    var state = exports.extractAddressComponent('administrative_area_level_1', false, addressComponents);
    var street = [
        exports.extractAddressComponent('street_number', false, addressComponents),
        exports.extractAddressComponent('route', false, addressComponents),
    ]
        .filter(function (str) { return str; })
        .join(' ');
    var zipCode = exports.extractAddressComponent('postal_code', false, addressComponents);
    return {
        city: city,
        state: state,
        street: street,
        zipCode: zipCode,
        shortname: street
    };
};
exports.parseGoogleMapsResponse = function (googlePlaceId) {
    return new Promise(function (resolve) {
        ;
        react_places_autocomplete_1.geocodeByPlaceId(googlePlaceId, function (res) { return res; }).then(function (geocodeRes) {
            if (!geocodeRes ||
                !geocodeRes.length ||
                !geocodeRes[0].address_components) {
                return;
            }
            react_places_autocomplete_1.getLatLng(geocodeRes[0]).then(function (latLng) {
                if (!latLng || !latLng.lat || !latLng.lng) {
                    return;
                }
                resolve(__assign({ googlePlaceId: googlePlaceId }, exports.parseGeocode(geocodeRes[0].address_components), { printableAddress: geocodeRes[0].formatted_address, lat: latLng.lat, lng: latLng.lng }));
            });
        });
    });
};
